import { TransText, type TransTextKeys } from '@/i18n/trans/text';
import type { BookingTripSummaryDTO } from '@/types/dto/agent';
import { cn } from '@/utils/cn';
import { format, formatTime } from '@/utils/dateTime';
import { Icons, Typography } from '@fleet/webshop-ui';
import type { FC } from 'react';

interface TicketTripSummariesProps {
  title: TransTextKeys;
  tripSummaries: Array<BookingTripSummaryDTO>;
  isRefunded: boolean;
}

const TicketTripSummaries: FC<TicketTripSummariesProps> = ({
  title,
  tripSummaries,
  isRefunded,
}) => {
  return (
    <div className="flex flex-1 flex-col gap-4">
      <Typography variant="body1-bold" className="text-dark">
        <TransText i18nKey={title} values={{ count: tripSummaries.length }} />
      </Typography>
      {tripSummaries.map((trip) => (
        <div key={trip.id} className="flex flex-col gap-1">
          <div
            className={cn('flex flex-wrap items-center gap-x-2 text-primary', {
              'text-neutral': isRefunded,
            })}
          >
            <Typography variant="body1-bold">{trip.origin?.name}</Typography>
            <Icons.arrowRight className="h-4 w-4" />
            <Typography variant="body1-bold">
              {trip.destination?.name}
            </Typography>
          </div>
          <div className="flex gap-0.5">
            {trip.origin?.time && (
              <>
                <Typography variant="body2" className="text-neutral">
                  {format(trip.origin.time, 'EEE, dd MMM yyyy')}
                </Typography>
                <Typography variant="body2" className="text-neutral">
                  &#8226;
                </Typography>
                <Typography variant="body2" className="text-neutral">
                  {formatTime(trip.origin.time)}
                </Typography>
              </>
            )}
            {Boolean(trip.transfers) && (
              <>
                <Typography variant="body2" className="text-neutral">
                  &#8226;
                </Typography>
                <Typography
                  variant="body2"
                  className={cn('text-error-text', {
                    'text-neutral': isRefunded,
                  })}
                >
                  <TransText
                    i18nKey="transfersCount"
                    values={{ count: trip.transfers }}
                  />
                </Typography>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TicketTripSummaries;
